import React from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash.groupby';
import {
  ACTIONS,
  TYPES_INFO,
  TYPE_CALLBACK,
  TYPE_INVALID,
  TYPE_NEGATIVE,
  TYPE_POSITIVE
} from '../helpers/contacts';
import { scrollToVisibleSelector } from '../helpers/dom';

class StatusWidget extends React.Component {
  render() {
    const actionsByType = groupBy(ACTIONS, 'type');
    const actions = Object.keys(TYPES_INFO).map(group => (
      <div className="col-md-3" key={`group_${group}`}>
        <h3>{TYPES_INFO[group].title}</h3>
        <p>{TYPES_INFO[group].info}</p>
        {actionsByType[group].map(actionItem => (
          <button
            key={`button_${actionItem.action}`}
            type="button"
            style={{
              margin: 10,
              ...(actionItem.action === this.props.formData
                ? { border: '3px solid black' }
                : {})
            }}
            className={`btn btn-default save-call ${
              actionItem.type === TYPE_INVALID ? 'btn-danger' : ''
            } ${actionItem.type === TYPE_NEGATIVE ? 'btn-danger' : ''} ${
              actionItem.type === TYPE_CALLBACK ? 'btn-warning' : ''
            } ${actionItem.type === TYPE_POSITIVE ? 'btn-success' : ''}
    `}
            onClick={() => {
              scrollToVisibleSelector('button.save-call');
              if (this.props.onChange) {
                this.props.onChange(actionItem.action);
              }
            }}
          >
            {actionItem.label}
          </button>
        ))}
      </div>
    ));
    return <div className="row">{actions}</div>;
  }
}

StatusWidget.propTypes = {
  onChange: PropTypes.func,
  formData: PropTypes.string
};

export default StatusWidget;



// WEBPACK FOOTER //
// ./src/components/StatusWidget.js